export default __webpack_public_path__ + "static/media/startTradeIcon3.bc4ce374.webp";